module.exports = __webpack_public_path__ + "static/img/wap_signin_logo_dou.ef9291e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sys/login/wap_signin_logo_dou.png
// module id = RVkp
// module chunks = 1